import { FoodLogOnDate } from "@corpuscomplete/core-ui/nutrition/food-log";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/personal/food-log/")({
  component: () => (
    <Navigate
      to="/personal/food-log/$date"
      params={{ date: Temporal.Now.plainDateISO() }}
      replace
    />
  ),
  loader: async ({ context: { zero, actor } }) => {
    if (!zero) return;
    void FoodLogOnDate.preload(zero, actor, Temporal.Now.plainDateISO());
  },
});
